require('jquery');

import 'font-awesome/scss/font-awesome.scss';  
import '../scss/app.scss';
import 'bootstrap'; // import  if using Bootstrap  JS plugins


if (module.hot) module.hot.accept()

class Fission {
	
	/**
	*  Initialize all JS
	*/
	static init() {
		this.someProperty = '';
		
		$(() => {
			this.initSomeMethod();
			
		});
		
	}
	/**
	* Comment for method
	*/
	static initSomeMethod() {

		function stickyNav() {
			var navbarOffset = $('header > .nav-container').outerHeight();
			if ($('#navbarResponsive').css('display') == 'flex') {
				//console.log(window.pageYOffset);
				//console.log(navbarOffset);
				if (window.pageYOffset >= navbarOffset) { 
					navbar.classList.add("sticky");
					$('#main').css('margin-top', '90px');
				} else {
					navbar.classList.remove("sticky");
					$('#main').css('margin-top', '0');
				}
			} else {
				$('#main').css('margin-top', '0');
			}
		}

		function initSlick() {
			$(".bb-image-slider").slick({
				dots: false,
				nextArrow: '<i class="fa fa-arrow-right"></i>',
				prevArrow: '<i class="fa fa-arrow-left"></i>',
				autoplay: true,
				autoplaySpeed: 5000,
			});
		}

		function removeEmptyFLBuilder() {
			$(".fl-builder-content").each(function(){
				if ($(this).is(':empty')) {
					$(this).remove();		
				}
			});
		}

		function downloadResource() {
			/*
			$('#resourceDownloadModal form').on('submit', function(e) {
				e.preventDefault();
				Cookies.set('resource_url', document.location.href);
				$(this)[0].submit();
			});
			if (document.location.pathname.indexOf("/resources/") == 0 && Cookies.get('resource_url') == 'download') {
				$('.resource-download').removeAttr('data-target').removeAttr('data-toggle');
			} else if (document.location.pathname == "/resources/" && Cookies.get('resource_url')) {
				window.location = Cookies.get('resource_url');
				Cookies.set('resource_url', 'download');
			}
			*/
			if ($('.resource-download').length > 0 && Cookies.get('vrl-signed-up') == 'true') {
				$('.resource-download').removeAttr('data-target').removeAttr('data-toggle');
			}

			$(".sign-up-form").on('submit', (e) => {
				e.preventDefault();
				const form = $(e.currentTarget);
				const formData = form.serializeArray();
				$.ajax( {
					url: '/wp-json/vrl/v1/submit-signup-form',
					data: formData,
					method: 'POST',
					beforeSend: ( xhr ) => {
					}
				})
				.done((res) => {
                    form.find('*').addClass('hide');
                    $('#resourceDownloadModal .success').removeClass('hide');
                    form.find('.thank-you-message').removeClass('hide');
					Cookies.set('vrl-signed-up', "true", { expires: 30 });
					$('.resource-download').removeAttr('data-target').removeAttr('data-toggle');
					
				})
				.fail(() => {
					form.find('.error').removeClass('hide');
				})
			});
		}

		window.onscroll = function() {
			stickyNav();
		};

		$(document).ready(function() {
			stickyNav();
			initSlick();
			removeEmptyFLBuilder();
			downloadResource();
		});

		$(window).resize(function() {
			stickyNav();
		});

	}
}

Fission.init();



// WEBPACK FOOTER //
// ./assets/src/js/app.js